
import { yupResolver } from '@hookform/resolvers/yup';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid2, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import StepContainer from '../components/step-container';
import { useStore } from 'src/store/StoreContext';
import {Filter} from "bad-words";

const filter = new Filter();
  
export class GPDetailsFormModel {
    gpDetails: string;
    doctorName?: string;
    centerName?: string;
    address?: string;
    suburb?: string;
    postCode?: string;
  
    constructor(data: any) {
      this.gpDetails = data.gpDetails;
      if (data.gpDetails === 'YES') {
        this.doctorName = data.doctorName;
        this.centerName = data.centerName;
        this.address = data.address;
        this.suburb = data.suburb;
        this.postCode = data.postCode;
      }
    }
  }
  
  const schema = yup.object().shape({
    gpDetails: yup.string().required('Please select an option'),
    doctorName: yup.string().when('gpDetails', {
      is: (gpDetails: string) => gpDetails === 'YES',
      then: (schema) => schema.required('Doctor Name is required').matches(/^[A-Za-z\s]+$/,'Only alphabets are allowed').test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    }),
    centerName: yup.string().when('gpDetails', {
      is: (gpDetails: string) => gpDetails === 'YES',
      then: (schema) => schema.required('Center Name is required').matches(/^[A-Za-z\s]+$/,'Only alphabets are allowed').test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    }),
    address: yup.string().when('gpDetails', {
      is: (gpDetails: string) => gpDetails === 'YES',
      then: (schema) => schema.test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    }),
    suburb: yup.string().when('gpDetails', {
      is: (gpDetails: string) => gpDetails === 'YES',
      then: (schema) => schema.required('Suburb is required').matches(/^[A-Za-z\s]+$/,'Only alphabets are allowed').test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),
    }),
    postCode: yup.string().when('gpDetails', {
      is: (gpDetails: string) => gpDetails === 'YES',
      then: (schema) => schema.required('Postal Code is required').matches(/^\d{4}$/, 'Postal Code must be 4 digits'),
    }),
  });
  

  export const GPDetails = () => {
    const service = useStore()?.service;
    const { control, handleSubmit, watch, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
        //defaultValues: service?.gpDetails
      });

      const gpDetails = watch('gpDetails');

      const onSubmit = (data: any) => {
        service?.updateGPDetails(data);
      };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
        <StepContainer 
        icon='fluent-color:people-list-20' 
        title='General Practitioner Information'
        cancelButtonProps={{disabled: service?.contentLoading}}
        confirmButtonProps={{type:'submit', disabled: service?.contentLoading,loading: service?.contentLoading}}>
        <Grid2 container>
            <Grid2 size={12}>
            <FormControl error={!!errors.gpDetails}>
                  <FormLabel>{'Do you want the lab to share the test results with your GP?'}</FormLabel>
                  <Controller
                  name={`gpDetails`}
                  control={control}
                  render={({ field, fieldState }) => (
                  <RadioGroup
                  row
                  {...field}
                  value={field.value || ''}
                  >
                  <FormControlLabel value="YES" control={<Radio />} label="Yes" />
                  <FormControlLabel value="NO" control={<Radio />} label="No" />
                  </RadioGroup>
                  )}
                  />
                  {errors.gpDetails && (
                  <FormHelperText>{'Please select an option'}</FormHelperText>
                  )}
                  </FormControl>
            </Grid2>
            <Grid2 size={{xs:12,md:6}}>
            {gpDetails === 'YES' ? <GPDetailsForm control={control} errors={errors} /> : <></>}
            </Grid2>
        </Grid2>
        
        </StepContainer>
        </form>
    )
  }
  
    const RequiredLabel = (label: string) => (
  <span>
    {label} <span style={{ color: 'red' }}>*</span>
  </span>
);
  const GPDetailsForm = ({ control, errors }:any) => {
    return (
      <Grid2 container spacing={2}>
        <Grid2 container spacing={1} size={{ xs: 12, sm: 6 }}>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="doctorName"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  margin='dense'
                  size='small'
                  {...field}
                  slotProps={{
                    inputLabel:{
                        shrink: Boolean(field.value)
                    }
                }}
                  label={RequiredLabel("Doctor Name")}
                  variant="outlined"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="centerName"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  margin='dense'
                  slotProps={{
                    inputLabel:{
                        shrink: Boolean(field.value)
                    }
                }}
                  size='small'
                  {...field}
                  label={RequiredLabel("Center Name")}
                  variant="outlined"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="address"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  margin='dense'
                  slotProps={{
                    inputLabel:{
                        shrink: Boolean(field.value)
                    }
                }}
                  size='small'
                  {...field}
                  label="Address"
                  variant="outlined"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="suburb"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  margin='dense'
                  slotProps={{
                    inputLabel:{
                        shrink: Boolean(field.value)
                    }
                }}
                  size='small'
                  {...field}
                  label={RequiredLabel("Suburb")}
                  variant="outlined"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Controller
              name="postCode"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                slotProps={{
                  inputLabel:{
                      shrink: Boolean(field.value)
                  }
              }}
                  margin='dense'
                  size='small'
                  {...field}
                  label={RequiredLabel("Postal Code")}
                  variant="outlined"
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid2>
        </Grid2>
        <Typography variant="body2" color="textSecondary">Note : Fields marked with an asterisk (*) are required.</Typography>
      </Grid2>
        
        

    );
  };
  